import PatternBackground from './PatternBackground';

export { type PatternBackgroundProps } from './PatternBackground';
export default PatternBackground;
